module.exports = __webpack_public_path__ + "static/media/IconeSemFundo.41cf35c3.png";